/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<void>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<void>> => {
  return axios.request({
    url: `/user`,
    // @ts-ignore for sm-axios
    urlTemplate: '/user',
    method: 'PATCH',
    data: request.body,
  })
}

/**
 * update an user password
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<void>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<void> => {
  await operationWithAxiosResponse(axios, request)
}

export interface Request {
  body: {
    token?: string
    password?: string
    [k: string]: any
  }
}

